import { Component, EventEmitter, forwardRef, Input, Output, ViewEncapsulation } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { FieldOption } from '@app/shared/models/field.interface';

@Component({
  selector: 'vfs-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  styleUrls: ['./checkbox-group.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CheckboxGroupComponent)
    }
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class CheckboxGroupComponent {
  @Input() formControlName: string;
  @Input() formControl: FormControl;
  @Input() options: Array<FieldOption>;
  @Input() value: any;

  @Output() changeValue = new EventEmitter<MatCheckboxChange>();

  onChange = (rating: number) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  change(event: MatCheckboxChange): void {
    this.changeValue.emit(event);
  }
}
